import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';

import SpecificationFiles from './SpecificationFiles';

const styles = StyleSheet.create({
  descriptionContainer: {
    marginHorizontal: commonStyles.marginHorizontal,
  },
  descriptionTitle: {
    ...commonStyles.fontM,
    marginBottom: 5,
    fontWeight: 'bold',
  },
  description: {
    ...commonStyles.fontS,
    marginBottom: 25,
    paddingRight: 60,
  },
});

function DescriptionPage({ description, files, t }) {
  return (
    <View style={styles.descriptionContainer} wrap={false}>
      <Text style={styles.descriptionTitle}>{t('additional_description')}</Text>
      <Text style={styles.description}>{description || t('no_specification_description')}</Text>
      {files?.length > 0 && <SpecificationFiles files={files} />}
    </View>
  );
}

export default withTranslation('specification')(DescriptionPage);
